/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICittaEnquireFormViewProps } from './citta-enquire-form';

export default (props: ICittaEnquireFormViewProps) => {
    return (
        <div className={`citta-enquire-form ${props.config.className || ''}`}>
            {props.EnquireButton}
            {props.ModalItem}
        </div>
    );
};
